export default function bdiIiScoreDescription(number) {
  if (number <= 9) return "score normal";
  if (number <= 18) return "dépression légère";
  if (number <= 29) return "dépression modérée";
  return "dépression sévère";
}